import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { AppButton } from './AppButton';
interface AppModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showCloseButton?: boolean;
}
export function AppModal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  showCloseButton = true
}: AppModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-49">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/80 backdrop-blur-sm transition-opacity duration-200" onClick={onClose} data-id="element-50" />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4" data-id="element-51">
        <div className={cn('relative bg-[#1f1f1f] border border-white/[0.12] rounded-2xl shadow-2xl w-full', 'max-h-[90vh] flex flex-col', sizeClasses[size])} onClick={e => e.stopPropagation()} data-id="element-52">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-5 border-b border-white/[0.10]" data-id="element-53">
            <h2 className="text-xl font-semibold text-white" data-id="element-54">{title}</h2>
            {showCloseButton && <button onClick={onClose} className="p-2 text-white/30 hover:text-white/60 hover:bg-white/[0.06] rounded-lg transition-all duration-180" data-id="element-55">
                <X className="w-5 h-5" data-id="element-56" />
              </button>}
          </div>

          {/* Body */}
          <div className="px-6 py-6 max-h-[calc(100vh-200px)] overflow-y-auto custom-scrollbar" data-id="element-57">
            {children}
          </div>

          {/* Footer */}
          {footer && <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-white/[0.10] bg-[#191919] rounded-b-lg" data-id="element-58">
              {footer}
            </div>}
        </div>
      </div>
    </div>;
}